import styled from '@emotion/styled';
import { theme } from '@revenuemarket/design';

import { LandingTypographyProps, TypographyProps } from '../types/typography';

interface StyledTypography extends Omit<TypographyProps, 'color '> {
  $color?: string;
}

interface StyledLandingTypoGraphy extends Omit<LandingTypographyProps, 'color '> {
  $color?: string;
}

export const Typography = styled.span<StyledTypography>`
  font-size: ${({ variant }) => theme.typography[variant].size}px;
  line-height: ${({ variant }) => theme.typography[variant].lineHeight}px;
  color: ${({ $color }) => ($color ? $color : theme.colors.grayscale200)};
  font-weight: ${({ variant, weight }) => weight ?? theme.typography[variant].weight};
  ${({ useEllipsis }) =>
    useEllipsis &&
    `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  `}
  ${({ inlineCss }) => inlineCss};
`;

export const LandingTypography = styled.div<StyledLandingTypoGraphy>`
  font-size: ${({ variant }) => theme.landingTypography[variant].size}px;
  line-height: ${({ variant }) => theme.landingTypography[variant].lineHeight};
  color: ${({ $color }) => ($color ? $color : theme.colors.grayscale200)};
  font-weight: ${({ variant, weight }) => weight ?? theme.landingTypography[variant].weight};
  letter-spacing: ${({ variant }) => theme.landingTypography[variant].letterSpacing};
  ${({ useEllipsis }) =>
    useEllipsis &&
    `
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
`}
  ${({ inlineCss }) => inlineCss};
`;
